@if(product) {
<div class="row my-1 product-item p-1">
  <atx-image
    [imageUrl]="product?.mainImageUrl"
    [maxWidth]="imageMaxSize"
    atxCardImage="top"
    failedLoadIconSize="1x"
    fallbackImageUrl="static/images/placeholder-image.jpg"
    class="col-4"
  ></atx-image>
  <div class="align-self-center product-info d-flex flex-column px-3 col-8">
    <span>{{ product?.articleTitle }}</span>
    <span class="font-weight-bold">{{
      product?.productId | productId: productIdAdditionalPrefixRexExp()
    }}</span>
    <atx-product-prices
      [prices]="product?.priceRanges?.[0]"
      [showWholeSalePrices]="showWholeSalePrices()"
      [showMarkup]="showMarkupPrice()"
      [showWspdPrice]="showWspdPrice()"
    ></atx-product-prices>
  </div>
</div>

}
